/* eslint eqeqeq: 'off' */
import * as types from '../action/actionTypes';
import * as url from '../api/url';
import APIutil from '../api/APIutils';
import {global_error_handling} from './GlobalErrorMgmtAction';

// GET Method for Zones,( Retrieve all zones available in Tracer Ensemble Tenant Services)

export function GetZonesList() { 
     return function (dispatch) {
         return APIutil.getDataAPI(url.get_Zones).then(response => {
            dispatch(global_error_handling(response));  
            if(response != null && response != undefined)
             dispatch(actionToStoreSuccess(response,types.GET_ZONES_LIST_SUCCESSFULL));
         }).catch(error => {
             throw error;
         })
     }
 }


//Submit / Post Zones
export function PostZones(data) { 
    return function (dispatch) {
       return APIutil.postData(url.post_Zone,data).then(response => {
        dispatch(global_error_handling(response));  
           if(response.status == 200)
          dispatch(GetZonesList());
        }).catch(error => {
            throw error;
        })
    }
}

//Update(put) Zones
export function UpdateZone(data) { 
    return function (dispatch) {
        var zoneId = data.ZoneId;
       return APIutil.editDataAPI(url.put_Zone + zoneId,data).then(response => {
        dispatch(global_error_handling(response));  
        if(response.status == 200)
             dispatch(GetZonesList());
        }).catch(error => {
            throw error;
        })
    }
}

// GET Method for Buildings,( Retrieve all Buildings available in Tracer Ensemble Tenant Services)

export function GetBuildingsList() { 
     return function (dispatch) {
         return APIutil.getDataAPI(url.get_Buildings_List).then(response => {
            dispatch(global_error_handling(response));  
            if(response != null && response != undefined && response.length > 0)
               dispatch(actionToStoreSuccess(response,types.GET_BUILDINGS_LIST_SUCCESSFULL));
         }).catch(error => {
             throw error;
         })
     }
 }


 



 //Delete Method for deleting single or multiple zones

export function DeleteZone(zones_to_be_deleted) { 
    return function (dispatch) {
       return APIutil.deleteDataAPI(url.delete_Zones,zones_to_be_deleted).then(response => {
        dispatch(global_error_handling(response));  
           if(response.status == 200)
               dispatch(GetZonesList());
        }).catch(error => {
            throw error;
        })
    }
}




 // GET Method for Members by Building ID,( Retrieve all Members based  on building ID)

 export function GetBuildingMembersList(buildingID) { 
    return function (dispatch) {
      // return APIutil.getDataAPI(url.get_Buildings_List+buildingID+"members").then(response => {
       return APIutil.getDataAPI(url.get_Building_Members_List+buildingID+"/members").then(response => {
        dispatch(global_error_handling(response));  
            if(response != null && response != undefined && response.length > 0)
            dispatch(actionToStoreSuccess(response,types.GET_MEMBERS_LIST_SUCCESSFULL));
        }).catch(error => {
            throw error;
        })
    }
}

 



 //Get Family members based on family types 
//  family=1(Space)
// family=11(Area)
// family=7(IO-BinaryPoints)

 export function GetMembersFromFamily(buildingId,familyId) { 
    return function (dispatch) {
       return APIutil.getDataAPI(url.get_Buildings_List+buildingId+"/members/"+familyId).then(response => {
        dispatch(global_error_handling(response));  
             if(response != null && response != undefined)
             dispatch(actionToStoreSuccess(response,types.GET_MEMBERS_LIST_SUCCESSFULL));
        }).catch(error => {
            throw error;
        })
    }
}





/* Action to Store method returns the action type with the API response. The response object{type,response}
 will be returned to the Reducer checking it type and updates the state. */

export function actionToStoreSuccess(response,actionType){
    return{
        type: actionType,
        getResponse: response,
    }
}

//Client Side state management

export const SaveZoneDetailsforclient = DataForState => ({
    type: types.GET_ZONES_DETAILS_FOR_STATE_SUCCESSFULL,
    Data: DataForState
  }
  );















